import { v4 as uuid } from 'uuid';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { DOC_TYPES, base64ToBlob, useStores } from '~/utils';
import CreditSimulationSelfie from './CreditSimulationSelfie';

const CreditSimulationSelfieContainer = () => {
  const navigate = useNavigate();
  const { creditProducts } = useStores();

  const handleSubmit = async (capturedImage: string) => {
    const blob = base64ToBlob(capturedImage);

    const picture = {
      uri: capturedImage,
      name: `${uuid()}.jpg`,
      mimeType: 'image/jpeg',
      type: DOC_TYPES.SELFIE,
      size: blob.size,
      blob: blob,
    };

    await creditProducts.creditProductsImageValidation(picture);
    navigate(Routes.CREDIT_SIMULATION_METHOD);
  };

  return <CreditSimulationSelfie handleSubmit={handleSubmit} />;
};

export default observer(CreditSimulationSelfieContainer);
